
import {Vue} from "vue-class-component";

export default class MySongs extends Vue {}
